<template>
  <div>
    <v-menu offset-y min-width="150px">
      <template #activator="{on}">
        <v-btn icon v-on="on">
          <v-icon color="nx-primary--lighten-5">more_vert</v-icon>
        </v-btn>
      </template>
      <v-list>
        <nx-list-action-preview list v-if="preview" :id="id" :type="type" />
        <nx-list-action-metadata list v-if="metadata" :id="id" :type="type" />

        <template v-if="cloneable">
          <v-list-tile @click="$emit('click:clone', item)">
            <v-list-tile-action>
              <v-icon>content_copy</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>{{ $t('message.bag.actions.clone') }}</v-list-tile-title>
          </v-list-tile>
        </template>

        <v-list-tile v-if="editable" :to="{name: 'content.editor', params: { id, type }}">
          <v-list-tile-action>
            <v-icon>edit</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t('message.bag.actions.edit') }}</v-list-tile-title>
        </v-list-tile>

        <v-list-tile v-if="item.url" @click="onLink">
          <v-list-tile-action>
            <v-icon>link</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t('message.bag.actions.link') }}</v-list-tile-title>
        </v-list-tile>

        <template v-if="moveable">
          <v-list-tile @click="$emit('click:move', item)">
            <v-list-tile-action>
              <v-icon>public</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>{{ $t('message.bag.actions.move') }}</v-list-tile-title>
          </v-list-tile>
        </template>

        <template v-if="multisiteShareable">
          <v-list-tile @click="$emit('click:multisite', item)">
            <v-list-tile-action>
              <v-icon>dashboard_customize</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>{{ $t('message.bag.actions.multisite') }}</v-list-tile-title>
          </v-list-tile>
        </template>

        <v-list-tile v-if="renameable" @click="renameDialog = true">
          <v-list-tile-action>
            <v-icon>drive_file_rename_outline</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t('message.bag.actions.rename') }}</v-list-tile-title>
        </v-list-tile>

        <template v-if="deletable">
          <v-divider></v-divider>
          <v-list-tile @click="$emit('click:delete', item)">
            <v-list-tile-action>
              <v-icon>delete</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>{{ $t('message.bag.actions.delete') }}</v-list-tile-title>
          </v-list-tile>
        </template>

      </v-list>
    </v-menu>
    <nx-bag-rename-action v-if="renameable" :item="item" :active="renameDialog" @close="renameDialog = false"/>
  </div>
</template>

<script>
import NxBagRenameAction from '@/modules/bag/components/common/BagRenameAction';
import NxListActionPreview from '@/components/list/components/actions/ListActionPreview';
import NxListActionMetadata from '@/components/list/components/actions/ListActionMetadata';

/**
 * @emits click
 *
 * @param item
 */
export default {
  components: {
    NxListActionMetadata,
    NxListActionPreview,
    NxBagRenameAction,
  },
  props: {
    item: Object,
    deletable: Boolean,
    editable: Boolean,
    renameable: Boolean,
    moveable: Boolean,
    multisiteShareable: Boolean,
    cloneable: Boolean,
    preview: Boolean,
    metadata: Boolean,
  },
  data() {
    return {
      renameText: null,
      renameDialog: false,
    };
  },
  methods: {
    onEdit() {
      this.$router.push({
        name: 'entity.editor',
        params: { id: this.id, entity: this.type },
      });
    },
    onLink() {
      window.open(this.publicUrl);
    },
  },
  computed: {
    id() {
      return this.item.id;
    },
    image() {
      return this.item.thumbnailUrl;
    },
    type() {
      return this.item.type;
    },
    publicUrl() {
      return this.item.url;
    },
  },
};
</script>

<style lang="stylus" scoped>
@import "../../../../assets/stylus/variables.styl";

.list-item {
  background-color: $nx-primary--darken-2

  &__content {
    font-size: 16px
    font-weight: 500
    font-stretch: normal
    font-style: normal
    line-height: 1.25
    letter-spacing: normal
  }
}
</style>
